/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { } from '@insticator/insticator-ui'; // iui-material
import RatingsGeneralSection from 'pages/dashboard/ratings/ratingsmanager/configuration/ratingsgeneralsection/ratingsgeneralsection';
import RatingsColorSchemeSection from 'pages/dashboard/ratings/ratingsmanager/configuration/ratingscolorschemesection/ratingscolorschemesection';
// utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/ratings/ratingsmanager/configuration/configuration_styles';


/* ========== ~~~~~~~~~~ COMMENTING CONFIGURATION ~~~~~~~~~~ ========== */
const Configuration = (props) => {

  return (
    <div className={`configuration ${props.classes.configuration}`}>
      <RatingsGeneralSection/>
      <RatingsColorSchemeSection />
    </div>
  );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Configuration);
